<template>
    <rkm-modal
        large
        ref="Modal"
        title="Cadastro de acordo de nível de serviço (SLA)"
    >
        <Form
            :data="data"
            :originalSla="originalSla"
            :sla="sla"
            @save="close"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                {{ sla ? 'Salvar' : 'Incluir' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Mixins.
import { object } from '@/mixins'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalSla: null,
        prioridades: [],
        sla: null,
    }),
    methods: {
        open(sla = null) {

            this.resetForm()

            this.originalSla = sla
            this.sla = this.clone(sla)

            this.$refs.Modal.show()
        },
        close() {

            this.$refs.Modal.hide()
        },
        resetForm() {

            this.data.form.sla = []
        },
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    }
}
</script>